import React from 'react';

interface PreloaderProps {
  progress?: number;
  isFading?: boolean;
}

const Preloader: React.FC<PreloaderProps> = ({ progress = 0, isFading = false }) => {
  return (
    <div 
      className={`fixed inset-0 z-[9999] bg-black flex items-center justify-center transition-opacity duration-500 ${
        isFading ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img 
            src="/new-logo.png" 
            alt="Bargad.ai Logo" 
            className="h-16 w-auto object-contain"
            loading="eager"
            decoding="sync"
          />
        </div>
        
        {/* Progress Bar */}
        <div className="w-64 h-2 bg-[#26ab4d]/20 rounded-full overflow-hidden mb-4">
          <div 
            className="h-full bg-gradient-to-r from-[#26ab4d] to-[#1e8a3f] transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
        
        {/* Progress Percentage */}
        <p className="text-[#9a9a9a] text-sm font-semibold">
          {progress}%
        </p>
      </div>
    </div>
  );
};

export default Preloader;

